import { IFavoriteEntity } from '../../../types/results';
import { getSourceParams } from '../../../utils/getSourceParams';

interface IGetOfferChatSrcParams {
  offer: IFavoriteEntity | null;
  defaultMessage?: string;
  isEarlyAccess?: boolean;
}

export function getOfferChatSrc({ offer, defaultMessage, isEarlyAccess }: IGetOfferChatSrcParams): string {
  const source = getSourceParams();

  if (!offer) {
    return '';
  }

  const { agentInfo, entityCianId, dealType, entityType } = offer;

  return (
    `/dialogs/?hostType=frame&offerId=${entityCianId}` +
    `&dealType=${dealType}&offerType=${entityType}` +
    `${agentInfo?.name ? '&companionName=' + encodeURIComponent(agentInfo.name) : ''}` +
    `${agentInfo?.cianId ? '&companionId=' + encodeURIComponent(agentInfo.cianId) : ''}` +
    `${source ? `&parentSource=${source}` : ''}` +
    `${defaultMessage ? '&defaultMessage=' + encodeURIComponent(defaultMessage) : ''}` +
    `${isEarlyAccess ? '&isEarlyAccess=1' : ''}` +
    '&pageType=ListingFavorites'
  );
}
